import { ErrorType } from "../../../models/HttpError";

// models
import { Settlement } from "../../../models/Entities/Settlements/Settlement";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';

//State
import { AppState } from "../../../redux/reducers";
import { SettlementDetail } from "../../../models/Entities/SettlementDetails/SettlementDetail";
import { SettlementTotal } from "../../../models/Entities/SettlementTotals/SettlementTotals";

interface IProps {
    SettlementId: number;
    CurrencyCode: string;
}
  
  interface ConnectedProps {
    isLoading: boolean;
    isUpdating: boolean;
    isUpdatedSuccessfully: boolean;
    isLoadingSuccessfully: boolean;
    failOnUpdating: boolean;
    failOnLoading: boolean;
    isRecalculating: boolean;
    isRecalculatedSuccessfully: boolean;
    failOnRecalculating: boolean;
    error: ErrorType | undefined;
    entityError: ErrorType | undefined;
    TotalToSettle: number;
    TotalWithholdings: number;
    OwnerAmount: number;
    OwnerWithholdings: number;
    OwnerTotal: number;
    TeamAmount: number;
    TeamWithholdings: number;
    TeamTotal: number;
    // Totales del comprobante con el que se confirmó (0 hasta entonces)
    InvoiceFixedTotal: number | undefined;
    InvoiceTotal: number | undefined;
    InvoiceTaxRetention: number | undefined;
    InvoiceTotalToSettle: number | undefined;
  }
  
  interface DispatchProps {
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
    RecalculateSettlementById: typeof SettlementStore.actionCreators.RecalculateSettlementById;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    //const CurrentSettlement = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    //const CurrentSettlementDetails = CurrentSettlement?.details?.filter((detail: SettlementDetail) => detail.currency === ownProps.CurrencyCode) || [];

    const CurrentSettlement = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    const CurrentSettlementTotal: SettlementTotal | null = CurrentSettlement?.totals?.find((total: SettlementTotal) => total.currencyCode === ownProps.CurrencyCode) || null;

    return {
    isLoading: state.Settlement?.isLoadingAll,
    isUpdating: state.Settlement?.isLoadingAll,
    isUpdatedSuccessfully: state.Settlement?.successLoadingAll,
    isLoadingSuccessfully: state.Settlement?.successLoadingAll,
    failOnUpdating: state.Settlement?.failOnLoadingAll,
    failOnLoading: state.Settlement?.failOnLoadingAll,
    isDeleting: state.Settlement?.isDeletingOne,
    isDeletedSuccessfully: state.Settlement?.successDeletingOne,
    failOnDeleting: state.Settlement?.failOnDeletingOne,
    isRecalculating: ownProps.SettlementId && state.Settlement && state.Settlement.list ? state.Settlement.list.find((item: Settlement) => item.id === ownProps.SettlementId )?.isRecalculating : undefined,
    isRecalculatedSuccessfully: ownProps.SettlementId && state.Settlement && state.Settlement.list ? state.Settlement.list.find((item: Settlement) => item.id === ownProps.SettlementId )?.isRecalculatedSuccessfully : undefined,
    error: state.Settlement?.error,
    entityError: ownProps.SettlementId && state.Settlement && state.Settlement.list ? state.Settlement.list.find((item: Settlement) => item.id === ownProps.SettlementId )?.error : undefined,
    TotalToSettle: CurrentSettlementTotal?.totalValue,
    TotalWithholdings: CurrentSettlementTotal?.withholdRetention,
    OwnerAmount: CurrentSettlementTotal?.ownerAmount,
    OwnerWithholdings: CurrentSettlementTotal?.ownerAmountWithholding,
    OwnerTotal: CurrentSettlementTotal?.ownerAmountWithholdingTotal,
    TeamAmount: CurrentSettlementTotal?.teamAmount,
    TeamWithholdings: CurrentSettlementTotal?.teamAmountWithholding,
    TeamTotal: CurrentSettlementTotal?.teamAmountWithholdingTotal,
    InvoiceFixedTotal: CurrentSettlementTotal?.fixedTotalValue,
    InvoiceTotal: CurrentSettlementTotal?.totalInvoice,
    InvoiceTaxRetention: CurrentSettlementTotal?.totalTaxRetention,
    InvoiceTotalToSettle: CurrentSettlementTotal?.totalToSettle,
    }
  };
  
  export const mapDispatchToProps = {
    ...SettlementStore.actionCreators
  };